export const Footer = () => (
  <footer className="footer">
    Desarrollado por{' '}
    <a href="https://juan-bogado-dev.netlify.app/" target="_blank" rel="noopener noreferrer">
      Juan Miguel Bogado
    </a>
    {' '}- ¿Te gusta esta idea?{' '}
    <a href="https://wa.me/5491139180630" target="_blank" rel="noopener noreferrer">
      Contáctame
    </a>
  </footer>
);
